module.exports = class JsonAnimation {
  constructor($el) {
    let animation_path = $el.attr('data-jsonanimation');

    window.bodymovin.loadAnimation({
      container: $el[0],
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animation_path
    });
  }
};